import $ from 'jquery'
import { VNodeDirective } from 'vue'
import '~bootstrap/tooltip'

const tooltip = (el: HTMLElement, binding: VNodeDirective) => {
  if (binding.value !== binding.oldValue) {
    const target = $(el)
    const setting = binding.value ? binding.value : {}
    target.tooltip(setting)
  }
}

export default tooltip
